export default __webpack_public_path__ + "static/media/gage.b83a80b0.png";